import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Form, Field } from 'react-final-form';
import { FORM_ERROR } from 'final-form';
import { Button, Spin } from 'antd';
import { CheckboxField } from '../../atoms';
import {
  FORM_INVOICE_TERMS,
  FORM_INVOICE_CONFIRM,
} from '../../constants/formKeys';
import { FormActions } from '../../components';
import { fromInvoiceTermsFields } from '../../constants/forms/formInvoiceTerms';
import { confirmInvoicePost } from '../../actions/actionCreators/invoiceSearchActionCreators';
import { formValueSelector } from '../../reducers/reactFinalFormReducer';
import classifiersStore from '../../utils/classifiersStore';
import validateSchema from './validateSchema';
import FormStateToRedux from '../FormStateToRedux';
import { makeRffValidateFromLegacy } from '../rffLegacyValidateAdapter';

import './termsConditions.css';

export class InvoiceTermsConditions extends Component {
  static propTypes = {
    t: PropTypes.func.isRequired,
    hideConfirmModal: PropTypes.func.isRequired,
    hideTermsModal: PropTypes.func.isRequired,
    isLoading: PropTypes.bool.isRequired,
    invoiceFormValues: PropTypes.object,
    confirmInvoicePost: PropTypes.func.isRequired,
  };

  handleCancel = () => {
    const { hideConfirmModal, hideTermsModal } = this.props;

    hideConfirmModal();
    hideTermsModal();
  };

  onSubmit = async () => {
    const {
      invoiceFormValues,
      confirmInvoicePost,
      hideConfirmModal,
      hideTermsModal,
    } = this.props;

    const values = invoiceFormValues?.toJS
      ? invoiceFormValues.toJS()
      : invoiceFormValues;

    const res = await confirmInvoicePost(values);
    if (res?.error) {
      return { [FORM_ERROR]: 'submitFailed' };
    }

    hideTermsModal();
    hideConfirmModal();
  };

  render() {
    const { t, isLoading } = this.props;

    const validate = makeRffValidateFromLegacy(validateSchema, this.props, {});

    return (
      <Spin spinning={isLoading}>
        <Form
          onSubmit={this.onSubmit}
          validate={validate}
          render={({ handleSubmit, values }) => {
            const isAgree = values?.[fromInvoiceTermsFields.AGREE];

            return (
              <form className="from-invoice-terms" onSubmit={handleSubmit}>
                <FormStateToRedux form={FORM_INVOICE_TERMS} />
                <div className="from-invoice-terms__text">
                  {classifiersStore.getInvoiceConfirmationText()}
                </div>
                <Field
                  className="from-invoice-terms__agree-field"
                  name={fromInvoiceTermsFields.AGREE}
                  type="checkbox"
                  component={CheckboxField}
                  checkboxText={t('terms.agree')}
                  hasFeedback={false}
                />
                <FormActions>
                  <Button onClick={this.handleCancel}>
                    {t('terms.cancelBtn')}
                  </Button>
                  <Button type="primary" htmlType="submit" disabled={!isAgree}>
                    {t('terms.confirmBtn')}
                  </Button>
                </FormActions>
              </form>
            );
          }}
        />
      </Spin>
    );
  }
}

const getInvoiceFormValues = formValueSelector(FORM_INVOICE_CONFIRM);

const mapStateToProps = (state) => ({
  invoiceFormValues: getInvoiceFormValues(state),
});

const mapDispatchToProps = {
  confirmInvoicePost,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(InvoiceTermsConditions);
